export const courses = [
  {
    title: "Tabla for Beginners - Part 1",
    description:
      "Learn how to play the first Taal and accompany a Song with Tabla",
    image_link: "https://img-b.udemycdn.com/course/750x422/2333680_5980_4.jpg",
    tutor_name: "Tabla Visharad",
    rating: 4.5,
    level: "Beginner level",
    reviews: 105,
    enrolled: 1241,
    course_link: "https://www.udemy.com/course/tabla-for-beginners-part-1/",
  },
  {
    title: "Pianoforall - Incredible New Way To Learn Piano & Keyboard",
    description:
      "Learn Piano in WEEKS not years. Play-By-Ear & learn to Read Music. Pop, Blues, Jazz, Ballads, Improvisation, Classical",
    image_link: "https://img-c.udemycdn.com/course/750x422/238934_4d81_7.jpg",
    tutor_name: "Robin hall",
    rating: 4.7,
    level: "Bestseller",
    reviews: 47637,
    enrolled: 390185,
    course_link:
      "https://www.udemy.com/course/pianoforall-incredible-new-way-to-learn-piano-keyboard/",
  },
  {
    title: "Complete Guitar Lessons System - Beginner to Advanced",
    description:
      "All-in-one Guitar Course, Fingerstyle Guitar, Blues Guitar, Acoustic Guitar, Electric Guitar & Fingerpicking Guitarra",
    image_link: "https://img-c.udemycdn.com/course/750x422/42271_886a_9.jpg",
    tutor_name: "Erich Andreas",
    rating: 4.6,
    level: "Bestseller",
    reviews: 41461,
    enrolled: 292015,
    course_link:
      "https://www.udemy.com/course/complete-guitar-system-beginner-to-advanced/",
  },
  {
    title: "Learn To Play The Drums",
    description:
      "Become a drummer with a step by step programme to get you from being drumming novice to drumming expert",
    image_link:
      "https://s3.amazonaws.com/drumeoblog/beat/wp-content/uploads/2019/11/22114343/blog-graphics-labeled-drum-kit.jpg",
    tutor_name: "Billy Baker",
    rating: 4.8,
    level: "Bestseller",
    reviews: 3202,
    enrolled: 22030,
    course_link: "https://www.udemy.com/course/learndrums/",
  },
  {
    title: "Beginner Violin Lessons - VIOLIN MASTERY FROM THE BEGINNING",
    description:
      "Learn Beginner Violin - Learn Violin from Scratch - The most In depth beginner online Violin course. Violin Class Violin",
    image_link: "https://img-c.udemycdn.com/course/750x422/1582278_57ca_5.jpg",
    tutor_name: "Lesson Pros",
    rating: 4.7,
    level: "Bestseller",
    reviews: 3513,
    enrolled: 21952,
    course_link:
      "https://www.udemy.com/course/beginner-violin-lessons-violin-master-course/",
  },
  {
    title: "Learn to Play the Flute: Beginner Basics to Intermediate",
    description:
      "Learning to play the flute is incredibly rewarding, but getting started is a challenge. Let MusicProfessor help!",
    image_link: "https://img-c.udemycdn.com/course/480x270/324224_3c7d_9.jpg",
    tutor_name: "Lesson Pros",
    rating: 4.7,
    level: "Bestseller",
    reviews: 1680,
    enrolled: 8429,
    course_link: "https://www.udemy.com/course/beginnerflute/",
  },
];

export const classe = [
  {
    name: "Saz Music Classes And Instruments Store",
    image_link:
      "https://lh3.googleusercontent.com/p/AF1QipPF5y2_0BhDxyeaKbht1kRmhXKUpNnQtcJC9lSE=s1360-w1360-h1020",
    rating: 4.5,
    reviews: 105,
    location: "Pimple Saudagar, Pune",
    phone: "09035079569",
    actual_link:
      "https://www.justdial.com/Pune/Saz-Music-Classes-And-Instruments-Store-Below-City-Pride-Cinema-Near-Jagtap-Dairy-Chowk-Pimple-Saudagar/020PXX20-XX20-111121123431-E6H4_BZDET?ncatid=10332940&area=Chinchwad&search=Top%20Music%20Classes%20in%20Chinchwad,%20Pune&mncatname=Music%20Classes&search_id=a1613ad9b75c168cb44d46852d6b58d5425d5845a92efad4f583ec85b2afbaf0&abd_btn=&abd_heading=&bd=1",
  },
  {
    name: "Swarsiddh Kala Academy",
    image_link:
      "https://content.jdmagicbox.com/comp/pune/l7/020pxx20.xx20.150609102333.d8l7/catalogue/swarsiddh-kala-academy-shaniwar-peth-pune-dance-classes-for-kathak-1lx17zq0p7.jpg",
    rating: 4.8,
    reviews: 70,
    location: "Shaniwar Peth, Pune",
    phone: "07490966632",
    actual_link:
      "https://www.justdial.com/Pune/Swarsiddh-Kala-Academy-Near-Corporation-and-Nana-Nani-Park-Apte-Ghat-Shaniwar-Peth/020PXX20-XX20-150609102333-D8L7_BZDET?ncatid=10332940&area=&search=Top%20Music%20Classes%20in%20Pune&mncatname=Music%20Classes&search_id=f17e1a182701661581a6955a906c88ddb9816d6bb9d7c3d4ef27a905ec81af4b&abd_btn=&abd_heading=&bd=1",
  },
  {
    name: "Saregamma Music Institute",
    image_link:
      "https://lh3.googleusercontent.com/p/AF1QipPCNFXRMmDTlZ625ghdo6fg9tWReiiQvmuVxxkg=w1080-h608-p-no-v0",
    rating: 4.3,
    reviews: 192,
    location: "Viman Nagar, Pune",
    phone: "",
    actual_link:
      "https://www.justdial.com/Pune/Saregamma-Music-Institute-Near-Hermes-Drome-Society-Viman-Nagar/020PXX20-XX20-200122170551-L1I8_BZDET?ncatid=10332940&area=&search=Top%20Music%20Classes%20in%20Pune&mncatname=Music%20Classes&search_id=f17e1a182701661581a6955a906c88ddb9816d6bb9d7c3d4ef27a905ec81af4b&abd_btn=&abd_heading=&bd=1",
  },
  {
    name: "Omkar Tabla Classes",
    image_link:
      "https://content.jdmagicbox.com/comp/pune/y2/020pxx20.xx20.150709134630.l3y2/catalogue/omkar-music-classes-pimple-gurav-pune-music-classes-ko9wngmuhr.jpg",
    rating: 4.6,
    reviews: 41,
    location: "Pimple Gurav, Pune",
    phone: "07947421703",
    actual_link:
      "https://www.justdial.com/Pune/Omkar-Tabla-Classes-Ramkrushna-Mangal-Karyalya-Pimple-Gurav/020PXX20-XX20-150709134630-L3Y2_BZDET?ncatid=10332940&area=&search=Top%20Music%20Classes%20in%20Pune&mncatname=Music%20Classes&search_id=f17e1a182701661581a6955a906c88ddb9816d6bb9d7c3d4ef27a905ec81af4b&abd_btn=&abd_heading=&bd=1",
  },
  {
    name: "Waltz Institute Of Western & Classical Music & Dance",
    image_link:
      "https://content.jdmagicbox.com/comp/pune/82/020pg004582/catalogue/waltz-institute-of-western-and-classical-music-and-dance-akurdi-pune-music-classes-6o347avlis.jpg",
    rating: 4.3,
    reviews: 176,
    location: "Akurdi, Pune",
    phone: "09035060534",
    actual_link:
      "https://www.justdial.com/Pune/Waltz-Institute-Of-Western-Classical-Music-Dance-INOX-THEATRE-Akurdi/020PG004582_BZDET?ncatid=10332940&area=&search=Top%20Music%20Classes%20in%20Pune&mncatname=Music%20Classes&search_id=f17e1a182701661581a6955a906c88ddb9816d6bb9d7c3d4ef27a905ec81af4b&abd_btn=&abd_heading=&bd=1",
  },

  {
    name: "Anahat Sangeet Academy",
    rating: 4.3,
    reviews: 164,
    location: "Chinchwad, Pune",
    phone: "07411719197",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Tonality Musiks",
    rating: 4.7,
    reviews: 37,
    location: "Thergaon, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Oscar Music Academy",
    rating: 4.8,
    reviews: 5,
    location: "Pimpri, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Sama Music Academy",
    rating: 4.4,
    reviews: 62,
    location: "Nigdi Pradhikaran, Pune",
    phone: "09035169287",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Sama Music And Arts Academy",
    rating: 4.7,
    reviews: 9,
    location: "Nigdi Pradhikaran Road Akurdi, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Kalashri Sangeet Mahavidhyala",
    rating: 4.5,
    reviews: 75,
    location: "Shilodhe Nagar Sangavi, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Heartbeats Music Studio",
    rating: 4.9,
    reviews: 142,
    location: "Jayram Nagar Hinjewadi Phase 1, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Harmonium And Keyboard Classes",
    rating: 2.7,
    reviews: 3,
    location: "mukai chowk kiwale Dehu Road, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "House Of Music",
    rating: 3.8,
    reviews: 23,
    location: "Vishrantwadi, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Antarnaad Kala Academy",
    rating: 4.8,
    reviews: 230,
    location: "New DP Road Kothrud, Pune",
    phone: "08904257782",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Manjusha Sangeet Vidyalay",
    rating: 4.3,
    reviews: 70,
    location: "Hadapsar, Pune",
    phone: "08460527409",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Amit Music Classes",
    rating: 5.0,
    reviews: 37,
    location: "Part-2 Katraj, Pune",
    phone: "08460217535",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Saregamma Music Institute",
    rating: 4.3,
    reviews: 192,
    location: "Vimannagar Viman Nagar, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Cyril Music Academy",
    rating: 4.8,
    reviews: 28,
    location: "Kharadi, Pune",
    phone: "07490843112",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Rhythm Music Academy",
    rating: 4.9,
    reviews: 216,
    location: "Survey No 9 Kharadi, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Millennium School Of Music",
    rating: 4.2,
    reviews: 226,
    location: "Karve Nagar, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Aksharam Music Classes",
    rating: 4.8,
    reviews: 130,
    location: "Magarpatta Hadapsar, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Shri Vyankatesh Sangeet Vidyalay",
    rating: 4.8,
    reviews: 19,
    location: "Pune Satara Road Katraj, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Swargandhar Sangeet & Sahitya Prasar Sanstha",
    rating: 3.8,
    reviews: 22,
    location: "Dhankawadi, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Rythem Music Academy",
    rating: 4.3,
    reviews: 18,
    location: "Manajinagar Road Narhe Gaon, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Achievers Destination Academy",
    rating: 5.0,
    reviews: 6,
    location: "241/114 Bhawani Peth, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Rising Star Music Academy",
    rating: 4.8,
    reviews: 5,
    location: "Near Swagat Cornet Katraj, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Rising Star Music Academy",
    rating: 4.8,
    reviews: 5,
    location: "Dattanagar Road Katraj, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Genius Star Orchestra Music",
    rating: 4.3,
    reviews: 4,
    location: "Shivaji Nagr Road Shivaji Nagar, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Swar Samradni",
    location: "Link Road Chinchwad, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Awesong.in",
    location: "Pimple Saudagar Pimri Chinchwad, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Crescendo (Music Academy)",
    rating: 1.0,
    reviews: 1,
    location: "Vijayraj Colony Pimple Gurav, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "I N R I Academy (Classes)",
    location: "Dehu Road, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
  {
    name: "Achievers Destination Academy",
    location: "Kalyani Nagar-Vadgaon Sheri, Pune",
    phone: "",
    actual_link: "",
    image_link: "",
  },
];

export const tutors = [
  {
    id: 1,
    name: "Ravi Sharma",
    role: "Tabla Tutor",
    imageUrl:
      "https://media.istockphoto.com/id/156951730/photo/hanumant-ghadge-tabla-accompaniment-at-private-party.jpg?s=1024x1024&w=is&k=20&c=GE3VJ52GFke2qkysCX0FaT71_PMwMZUaxUpFAyAVByk=",
    lessons: 30,
    students: 20,
    experience: "15",
  },
  {
    id: 2,
    name: "Emily Williams",
    role: "Piano Tutor",
    imageUrl:
      "https://images.unsplash.com/flagged/photo-1570612861542-284f4c12e75f?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cGVyc29ufGVufDB8fDB8fA%3D%3D&amp;auto=format&amp;fit=crop&amp;w=500&amp;q=60",
    lessons: 20,
    students: 15,
    experience: "10 ",
  },
  {
    id: 3,
    name: "John Smith",
    role: "Guitar Tutor",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0203/9334/files/shutterstock_528522403_grande.jpg?v=1498304162",
    lessons: 25,
    students: 12,
    experience: "8",
  },
  {
    id: 4,
    name: "Sarah Johnson",
    role: "Drums Tutor",
    imageUrl:
      "https://www.shutterstock.com/image-photo/young-female-drummer-playing-drums-600nw-1775040899.jpg",
    lessons: 18,
    students: 10,
    experience: "6",
  },
];

const classes = classe.map((classItem, index) => ({
  id: index + 1,
  ...classItem,
}));

export { classes };
